export const CheckoutRoutes = {
    path: 'checkout',
    serialized: {
        path: ':hash',
    },
};
